import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import LoaderBlock from "shared/loader/LoaderBlock";
import { addKitchenFees, getKitchenFees } from "services/api/kitchen";
import toastify from "shared/toastr";

const RestaurantFee = (props) => {
  const [isLoading, setisLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    marketingFee: Yup.number()
      .typeError("Only digits allowed")
      .positive()
      .min(0)
      .required("Please enter Marketing Fee"),
    softwareFee: Yup.number()
      .typeError("Only digits allowed")
      .positive()
      .min(0)
      .required("Please enter Software Fee")
  });

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isValid },
  } = methods;

  useEffect(() => {
    getKitchenFee();
  }, []);

  const getKitchenFee = async () => {
    setisLoading(true);
    await getKitchenFees(props?.kitchen?.id)
      .then((res) => {
        const data = res.data;
        reset({
          marketingFee: data?.marketingFee,
          softwareFee: data?.softwareFee,
        });
        setisLoading(false);
      })
      .catch(() => {
        setisLoading(false);
      });
  };

  const onSubmit = async (data) => {
    const model = {
      kitchenId: props?.kitchen?.id,
      marketingFee: data.marketingFee,
      softwareFee: data.softwareFee,
    };
    setisLoading(true);
    await addKitchenFees(model)
      .then((res) => {
        toastify("success", res.message);
        setisLoading(false);
      })
      .catch((e) => {
        toastify("error", e.message);
        setisLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="details__wrapper">
        {isLoading ? (
          <LoaderBlock />
        ) : (
          <div className="details__wrapper__inner">
            <div className="form-row no-gutters">
              <div className="detailCard mb-0 pb-0">
                <h5>Restaurant Weekly Fees</h5>
              </div>

              <div className="col-md-12 mb-2 pb-2">
                <label htmlFor="marketingFee">
                  Marketing Fee<span className="mendatory">*</span>
                </label>
                <input
                  type="number"
                  placeholder="e.g. 15.00"
                  className={`form-control mb-0 ${
                    errors?.marketingFee ? "is-invalid" : ""
                  }`}
                  {...register(`marketingFee`)}
                />
                {errors?.marketingFee?.message && (
                  <div
                    className="invalid-feedback d-block"
                    style={{
                      position: "absolute",
                      margin: "0px",
                    }}
                  >
                    {errors?.marketingFee?.message}
                  </div>
                )}
              </div>

              <div className="col-md-12 mb-3 pb-3">
                <label htmlFor="softwareFee">
                  Software Fee<span className="mendatory">*</span>
                </label>
                <input
                  type="number"
                  placeholder="e.g. 15.00"
                  className={`form-control mb-0 ${
                    errors?.softwareFee ? "is-invalid" : ""
                  }`}
                  {...register(`softwareFee`)}
                />
                {errors?.softwareFee?.message && (
                  <div
                    className="invalid-feedback d-block"
                    style={{
                      position: "absolute",
                      margin: "0px",
                    }}
                  >
                    {errors?.softwareFee?.message}
                  </div>
                )}
              </div>

              <div className="button_wrapper">
                <button
                  className="btn apply_btn"
                  disabled={isLoading || !isValid}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default RestaurantFee;
